import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Account } from '../models/account';
import { environment } from '../../environments/environment';
import { HttpResponseInterface } from '../interfaces/iHttpResponse';
import { SubscriptionPlan } from '../models/subscriptionPlan';
import { UserSubscription } from '../models/userSubscription';

@Injectable({
  providedIn: 'root'
})

export class SubscriptionService {

    constructor(private http: HttpClient) {
    }

    public getSubDetail(sub_id):Observable<any>{
      return this.http.get(environment.apiEndpoint+`/api/stripe/subscription?subscription_id=${sub_id}`).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public getPlans(): Observable<SubscriptionPlan[]> {
        return this.http.get<SubscriptionPlan[]>(environment.apiEndpoint + `/api/subscription/plans`).pipe(
            map(res => {
                return res;
            })
        );
    }

    public getUserSubscriptions(): Observable<UserSubscription[]>{
        return this.http.get<any>(environment.apiEndpoint + `/api/user/subscription`).pipe(
            map(res => {
                let subs =[];
                res.forEach(subscription=>{
                    subs.push(new UserSubscription(subscription));
                })
                return subs;
            })
        );
    }

    public cancelSubscription(subscription_id): Observable<any>{
        return this.http.delete<any>(environment.apiEndpoint + `/api/stripe/subscription/${subscription_id}`).pipe(
            map(res => {
                return res;
            })
        );
    }
}
